'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var FIELD_META_PROP = exports.FIELD_META_PROP = 'data-__meta';
var FIELD_DATA_PROP = exports.FIELD_DATA_PROP = 'data-__field';


//////////////////
// WEBPACK FOOTER
// ./~/antd/lib/form/constants.js
// module id = 173
// module chunks = 35783957827783 65974612472484